import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Nav() {
  const [isOpen, setIsOpen] = useState(false);
  const links = ['DROPS', 'חנות', 'אודות', 'קהילה'];
  return <nav className="sticky top-0 z-50 bg-white brutal-border border-t-0 border-l-0 border-r-0" data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <div className="flex justify-between items-center h-20" data-id="element-114">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center" data-id="element-115">
            <span className="font-archivo text-4xl tracking-tighter hover:text-magenta transition-colors cursor-pointer" dir="ltr" data-id="element-116">
              REBEL
            </span>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8 space-x-reverse" data-id="element-117">
            {links.map(link => <a key={link} href={`#${link}`} className="font-black text-xl hover:text-electric hover:-translate-y-1 transition-transform" data-id="element-118">
                {link}
              </a>)}
            <button className="brutal-btn bg-black text-white px-6 py-2 text-xl hover:bg-acid hover:text-black" data-id="element-119">
              קנה עכשיו
            </button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-120">
            <button onClick={() => setIsOpen(!isOpen)} className="brutal-border p-2 bg-acid brutal-shadow brutal-active" data-id="element-121">
              {isOpen ? <X size={24} data-id="element-122" /> : <Menu size={24} data-id="element-123" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-124">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="md:hidden bg-white brutal-border border-l-0 border-r-0 border-b-0 overflow-hidden" data-id="element-125">
            <div className="px-4 pt-4 pb-6 space-y-4 flex flex-col" data-id="element-126">
              {links.map(link => <a key={link} href={`#${link}`} className="font-black text-2xl block border-b-4 border-black pb-2 hover:text-magenta hover:pl-4 transition-all" onClick={() => setIsOpen(false)} data-id="element-127">
                  {link}
                </a>)}
              <button className="brutal-btn bg-black text-white w-full py-4 text-2xl mt-4 hover:bg-electric" data-id="element-128">
                קנה עכשיו
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}